<script>
import qs from 'qs'
import { queryAdvert } from 'api/index'

export default {
  name: 'BannerAd',
  props: {
    position: {
      type: Number
    },
    relationId: {
      type: Number
    }
  },
  data() {
    return {
      advList: []
    }
  },
  created() {
    const { position, relationId } = this
    queryAdvert(
      qs.stringify({
        position,
        relationId
      })
    ).then(({ data, success } = {}) => {
      if (!success || !Array.isArray(data)) return
      this.advList = data.slice(0, 3)
    })
  },
  methods: {
    formatDescribe(str) {
      return ('' + str).split('*')
    }
  }
}
</script>

<template>
  <div v-if="advList.length" class="adv-wrap">
    <a v-if="advList.length === 1" class="single" :href="advList[0].link">
      <span class="title">{{ formatDescribe(advList[0].description)[0] }}</span>
      <span class="describe">{{
        formatDescribe(advList[0].description)[1]
      }}</span>
    </a>
    <template v-else>
      <a
        v-for="(item, index) in advList"
        :key="index"
        class="multiple"
        :class="{ thrd: advList.length > 2 }"
        :href="item.link"
      >
        <p class="title">{{ formatDescribe(item.description)[0] }}</p>
        <p class="describe">{{ formatDescribe(item.description)[1] }}</p>
      </a>
    </template>
  </div>
</template>

<style lang="postcss" scoped>
@import 'variable.css';

.adv-wrap {
  display: flex;
  @apply --widthcenter;
  margin-bottom: 10px;
  padding: 0 5px;
  border-radius: 4px;
  background-color: #fff;
  .single {
    display: block;
    width: 100%;
    padding: 14px 20px;
    @apply --text-ellipsis;
    color: var(--patch-color-text);
    span {
      vertical-align: middle;
    }
  }
  .multiple {
    flex: 1;
    display: block;
    max-width: 50%;
    padding: 15px 27px 15px 25px;
    text-align: center;
    @apply --text-ellipsis;
    color: var(--patch-color-text);
    p {
      @apply --text-ellipsis;
    }
  }
  .thrd {
    padding: 15px;
    max-width: 33.33%;
  }
  span.title {
    margin-right: 15px;
  }
  p.title {
    margin-bottom: 6px;
  }
  .title {
    font-size: 15px;
  }
  .describe {
    font-size: 12px;
  }
}
</style>
